export default __webpack_public_path__ + "static/media/agenda.9d666812.png";